import { render, staticRenderFns } from "./grid2.vue?vue&type=template&id=2834545b&scoped=true&"
import script from "./grid2.vue?vue&type=script&lang=js&"
export * from "./grid2.vue?vue&type=script&lang=js&"
import style0 from "./grid2.vue?vue&type=style&index=0&id=2834545b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2834545b",
  null
  
)

export default component.exports